import {
  Cancel01Icon,
  CheckmarkCircle02Icon
} from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  Button,
  ButtonSize,
  ButtonVariant,
  IconButton,
  IconButtonSize
} from "shared/components";

export const RequestSentView = ({ onClose }: { onClose: () => void }) => (
  <div className="relative flex flex-col items-center justify-center h-full p-6 text-center gap-4">
    <IconButton
      HugeIcon={Cancel01Icon}
      size={IconButtonSize.SM}
      borderLess
      className="absolute top-4 right-4"
      onClick={onClose}
    />

    <div className="p-5 bg-primary-20 rounded-full">
      <HugeiconsIcon
        icon={CheckmarkCircle02Icon}
        size={32}
        className="text-primary-500"
      />
    </div>

    <h2 className="text-xl font-bold text-content-1000">
      Request has been sent to the applicant
    </h2>

    <Button
      size={ButtonSize.BASE}
      variant={ButtonVariant.BASE}
      onClick={onClose}
    >
      Close
    </Button>
  </div>
);
